import { Global as s } from "./Global.js";
function u(e) {
  "@babel/helpers - typeof";
  return u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, u(e);
}
function y(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(c) {
      return Object.getOwnPropertyDescriptor(e, c).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function f(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? y(Object(r), !0).forEach(function(n) {
      h(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : y(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function h(e, t, r) {
  return t = b(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function b(e) {
  var t = g(e, "string");
  return u(t) == "symbol" ? t : t + "";
}
function g(e, t) {
  if (u(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (u(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var o = {
  widthCache: {},
  cacheCount: 0
}, v = 2e3, m = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, p = "recharts_measurement_span";
function w(e) {
  var t = f({}, e);
  return Object.keys(t).forEach(function(r) {
    t[r] || delete t[r];
  }), t;
}
var S = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || s.isSsr)
    return {
      width: 0,
      height: 0
    };
  var n = w(r), c = JSON.stringify({
    text: t,
    copyStyle: n
  });
  if (o.widthCache[c])
    return o.widthCache[c];
  try {
    var i = document.getElementById(p);
    i || (i = document.createElement("span"), i.setAttribute("id", p), i.setAttribute("aria-hidden", "true"), document.body.appendChild(i));
    var d = f(f({}, m), n);
    Object.assign(i.style, d), i.textContent = "".concat(t);
    var a = i.getBoundingClientRect(), l = {
      width: a.width,
      height: a.height
    };
    return o.widthCache[c] = l, ++o.cacheCount > v && (o.cacheCount = 0, o.widthCache = {}), l;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, j = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
export {
  j as getOffset,
  S as getStringSize
};
